import React, { useState } from 'react';
import { StarRatingButton, StarRatingStar, StarRatingWrapper } from '@/components/custom/star-rating';

export default function StarRating(props) {
  const { answerRate, liveClassId, questionId, answerId, onSubmit } = props;

  const [rate, setRate] = useState(answerRate);
  const [hover, setHover] = useState(0);

  const stars = [...Array(5)];

  function handleRate(currentRate) {
    setRate(currentRate);
    onSubmit(
      answerId
        ? {
            rating: currentRate,
            answerId
          }
        : {
            'live-classroom-id': Number(liveClassId),
            'live-classroom-question-id': Number(questionId),
            rating: currentRate
          }
    );
  }

  return (
    <StarRatingWrapper>
      {stars.map((_, index) => {
        const current = index + 1;

        return (
          <StarRatingButton
            key={index}
            onClick={() => handleRate(current)}
            onMouseEnter={() => setHover(current)}
            onMouseLeave={() => setHover(rate)}
            rate={(hover || rate) >= current}
          >
            <StarRatingStar />
          </StarRatingButton>
        );
      })}
    </StarRatingWrapper>
  );
}
